'use strict'

module.exports =
  setItem: (itemName, itemValue) ->
    window.localStorage.setItem(itemName, itemValue)

  itemExists: (itemName) -> !!window.localStorage.getItem(itemName)